export default {
  state: {
    isDataLoaded: false,
  },
  getters: {
    isDataLoaded(state) {
      return state.isDataLoaded;
    },
  },
  mutations: {
    resolvePageLoader(state) {
      state.isDataLoaded = false;
    },
    setPageLoader(state) {
      state.isDataLoaded = true;
    },
  },
};
